import { render, staticRenderFns } from "./DataStok.vue?vue&type=template&id=0ed529a4&"
import script from "./DataStok.vue?vue&type=script&lang=js&"
export * from "./DataStok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports